import { Link } from "react-router-dom";
import { RightArrowIcon } from "./RightArrow";

export default function Magazine({ data, magazinesContents }: any) {
  return (
    <section className="event__area section-pt-80 section-pb-30">
      <div className="container">
        <div className="event__inner-wrap">
          <div className="row">
            <div className="col-30">
              <div className="event__content">
                <div className="section__title mb-20">
                  <span className="sub-title">{data?.highlightTexts}</span>
                  <h2 className="title">Media Talkback Magazine</h2>
                </div>
                <p>{data?.description}</p>
                <div className="tg-button-wrap">
                  <Link
                    to={data?.link}
                    // target="_blank"
                    className="btn arrow-btn"
                  >
                    View All{" "}
                    {/* <img
                      src="assets/img/icons/right_arrow.svg"
                      alt="img-text"
                      className="injectable"
                      width={20}
                      height={20}
                    /> */}
                    <RightArrowIcon />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-70">
              <div className="event__item-wrap">
                <div className="row justify-content-center">
                  {magazinesContents?.nodes &&
                    magazinesContents.nodes.length > 0 &&
                    magazinesContents.nodes.map((item: any, index: number) => (
                      <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                        <div className="event__item shine__animate-item">
                          <div className="event__item-thumb">
                            <Link
                              to={item?.emagazineCpt?.pdfLink}
                              target="_blank"
                              className="shine__animate-link"
                            >
                              <img
                                src={item?.featuredImage?.node?.sourceUrl}
                                alt={item?.featuredImage?.node?.altText}
                                width={266}
                                height={212}
                              />
                            </Link>
                          </div>
                          <div className="event__item-content">
                            <span className="date">June, 2024</span>
                            <h2 className="title">
                              <Link
                                to={item?.emagazineCpt?.pdfLink}
                                target="_blank"
                              >
                                {item.title}
                              </Link>
                            </h2>
                            <Link
                              to={`/flipbook/${item.title}`}
                              state={{ data: item?.emagazineCpt?.pdfLink }}
                              className="shine__animate-link"
                            >
                              <i className="flaticon-arrow-right"></i>Read more
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="event__shape">
        <img
          src="/assets/img/events/event_shape.png"
          alt="img-text"
          className="alltuchtopdown"
          width={135}
          height={92}
        />
      </div>
    </section>
  );
}
